export default __webpack_public_path__ + "static/media/newdoc.a1545a77.svg";